import API from '@/api/api';
import {computed} from 'vue';
import {useQuery} from '@tanstack/vue-query';
import {storeToRefs} from 'pinia';
import {useUserStore} from '@/stores/userStore';
import {parseZodSchema} from '@/api/models/parseZodSchema';
import {permissionListModel} from '@/api/models/permissions/permissionListModel';
import {permissionListQueryKey} from '@/api/queries/keys/permissionKeys';

export function usePermissionListQuery() {
    const {isAuthenticated, user} = storeToRefs(useUserStore());

    // Keyed by the user, so a login and an impersonation starting or ending each load their own list.
    const userId = computed(() => user.value?.id);
    const enabled = computed(() => isAuthenticated.value && !!userId.value);

    const {data, isPending} = useQuery({
        queryKey: permissionListQueryKey(userId),
        queryFn: () =>
            API.get('/api/permissions', true, true)
                .then(API.handle)
                .then(data => parseZodSchema(data, permissionListModel)),
        enabled,
        staleTime: 0,
        refetchOnWindowFocus: false,
    });

    const permissionList = computed(() => data.value ?? null);
    const isLoading = computed(() => enabled.value && isPending.value);

    return {permissionList, isLoading};
}
